import { JSX } from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    useGetIdentity,
    WithRecord,
    usePermissions,
    TopToolbar,
    ExportButton, CreateButton
} from 'react-admin';
import { permissionManager } from '../permissions/manager';
import {
    LinearProgress,
} from '@mui/material';

const ListActions: () => JSX.Element = (): JSX.Element => {
    const { permissions } = usePermissions();
    return (
        <TopToolbar>
            {/* Creating an admin is the narrower resource: HQ-API has always held it to a
                higher tier than reading or editing one. */}
                <CreateButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminUserList: () => JSX.Element = (): JSX.Element => {
    const { permissions } = usePermissions();
    const { isLoading, data } = useGetIdentity();

    const renderEditButton: (record: any) => JSX.Element = (record: any): JSX.Element => {
        if (isLoading) {
            return <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
        }
        const { id  } = data;
        if (record.id === id) {
            return <EditButton />
        } else if ( permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.edit') ) {
            return <EditButton />
        } else {
            return <></>
        }
    }

    return (
        <List actions={ <ListActions /> } >
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="email" />
                <TextField source="roles" />
                <WithRecord label="Actions" render={
                    (record: any): JSX.Element => {
                        return renderEditButton(record);
                    }
                } />
            </Datagrid>
        </List>
    );
}
